<!-- Updated customer-enquiry-list.component.html -->
<div class="container">
  <!-- View Toggle -->
  <div class="trainer-toolbar">
    <div class="left-tools">
      <button class="icon-button" [class.active]="viewMode === 'detail'" (click)="onViewChange('detail')">
        <i class="fa fa-list"></i>
      </button>
      <button class="icon-button" [class.active]="viewMode === 'card'" (click)="onViewChange('card')">
        <i class="fa fa-th-large"></i>
      </button>
    </div>

     <button class="add-entity-button" title="Add Enquiry">
      <i class="fa fa-plus" aria-hidden="true"></i>Add Enquiry</button>
  </div>

  <!-- Detail View -->
  <div class="trainer-card-list" *ngIf="viewMode === 'detail'">
    <div class="entity-card-header">
      <span>Enq. Date</span>
      <!-- <span>ID</span> -->
      <span>Organization Name</span>
      <span>Contact Person</span>
      <span>Email</span>
      <span>Subject</span>
      <!-- <span>Details</span> -->
      <span>Status</span>
      <span class="grid-column">Actions</span>
    </div>

    <div class="entity-card-row" *ngFor="let enquiry of enquiries">
      <span [title]="enquiry.createdDate">{{ enquiry.createdDate ? formatDate(enquiry.createdDate) : '' }}</span>
      <!-- <span [title]="enquiry.id">{{ enquiry.id | trimmer:15 }}</span> -->
      <span [title]="enquiry.name">{{ enquiry.name | trimmer:15 }}</span>
      <span [title]="enquiry.contactPerson">{{ enquiry.contactPerson | trimmer:15 }}</span>
      <span [title]="enquiry.email">{{ enquiry.email | trimmer:15 }}</span>
      <span [title]="enquiry.subject">{{ enquiry.subject | trimmer:15 }}</span>
      <!-- <span [title]="enquiry.subject">{{ enquiry.enquiryDetails | trimmer:15 }}</span> -->
      <span class="status-badge" [ngClass]="getStatusBadgeClass(enquiry.enquiryStatus)">
        <i class="fa fa-check-circle" *ngIf="isPositiveStatus(enquiry.enquiryStatus)"></i>
        {{ enquiry.enquiryStatus }}
      </span>

      <span class="actions" style="position: relative;">
        <!-- <span class="menu-wrapper"> -->
        <i class="fa fa-ellipsis-v menu-icon" (click)="toggleMenu($event, enquiry.id)"></i>

        <div class="dropdown-menu" *ngIf="activeMenuId === enquiry.id">
          <div class="menu-item" (click)="assign(enquiry)">
            <i class="fa fa-user-plus"></i> Assign
          </div>
          <div class="menu-item" (click)="reply(enquiry)">
            <i class="fa fa-reply"></i> Reply
          </div>
          <div class="menu-item" (click)="proceed(enquiry)">
            <i class="fa fa-arrow-right"></i> Proceed to Requisition
          </div>
          <div class="menu-item" (click)="openCancelPopup(enquiry.id)">
            <i class="fa fa-times-circle"></i> Cancel
          </div>
          <div class="menu-item" (click)="openViewDetailPopup(enquiry)">
            <i class="fa fa-note-sticky"></i> View Details
          </div>
        </div>
      </span>
      <!-- </span> -->
    </div>
  </div>

  <!-- Card View -->
  <div class="trainer-card-grid" *ngIf="viewMode === 'card'">
    <div class="trainer-card" *ngFor="let enquiry of enquiries">
      <div class="card-header">
        <div class="avatar-actions">
          <div class="avatar">{{ enquiry.name[0] }}</div>

          <div class="menu-wrapper">
            <i class="fa fa-ellipsis-v menu-icon" (click)="toggleMenu($event, enquiry.id)"></i>

            <div class="dropdown-menu" *ngIf="activeMenuId === enquiry.id">
              <div class="menu-item" (click)="assign(enquiry)">
                <i class="fa fa-user-plus"></i> Assign
              </div>
              <div class="menu-item" (click)="reply(enquiry)">
                <i class="fa fa-reply"></i> Reply
              </div>
              <div class="menu-item" (click)="proceed(enquiry)">
                <i class="fa fa-arrow-right"></i> Proceed to Requisition
              </div>
              <div class="menu-item" (click)="openCancelPopup(enquiry.id)">
                <i class="fa fa-times-circle"></i> Cancel
              </div>
              <div class="menu-item" (click)="openViewDetailPopup(enquiry.id)">
                <i class="fa fa-note-sticky"></i> View Details
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body">

        <h3 class="trainer-name">{{ enquiry.name }}</h3>
        <p class="info-line"><i class="fa fa-calendar"></i> {{ enquiry.createdDate ? formatDate(enquiry.createdDate) :
          '' }}</p>
        <p class="info-line"><i class="fa fa-user"></i> {{ enquiry.contactPerson | trimmer:15 }}</p>
        <p class="info-line"><i class="fa fa-envelope"></i> {{ enquiry.email | trimmer:25 }}</p>
        <p class="info-line"><i class="fa fa-phone"></i> {{ enquiry.mobileNumber }}</p>
        <p class="info-line"><i class="fa fa-info-circle"></i> <strong>Subject:</strong> {{ enquiry.subject | trimmer:15
          }}</p>

        <!-- Status Badge in Card View -->
        <div class="info-line">
          <i class="fa fa-flag"></i>
          <span class="status-badge" [ngClass]="getStatusBadgeClass(enquiry.enquiryStatus)">
            <i class="fa fa-check-circle" *ngIf="isPositiveStatus(enquiry.enquiryStatus)"></i>
            {{ enquiry.enquiryStatus }}
          </span>
        </div>

        <hr />
        <p><strong>Details:</strong> {{ enquiry.enquiryDetails | trimmer:15 }}</p>


      </div>
    </div>
  </div>

  <!-- Reply Modal -->
  <div class="modal" *ngIf="replyModalVisible">
    <div class="modal-content">
      <h3>Reply to Enquiry</h3>

      <!-- <div class="form-group">
        <label>From:</label>
        <input matInput [value]="replyFromEmail" disabled />
      </div> -->

      <div>
        <label>To:</label>
        <input matInput [value]="replyToEmail" disabled />
      </div>

      <div>
        <label>Subject:</label>
        <input matInput [(ngModel)]="replySubject" />
      </div>

      <div>
        <label>Response:</label>
        <textarea matInput rows="6" [(ngModel)]="replyBody"></textarea>
      </div>


      <div class="reply-container">
        <div>
          <label>Attachments:</label>
          <input type="file" multiple (change)="onFilesSelected($event)" />
        </div>

        <div class="modal-actions">
          <button (click)="sendReply()">Reply</button>
          <button (click)="resetReply()" type="button">Reset</button>
          <button (click)="closeReplyModal()" type="button">Cancel</button>
        </div>
      </div>



      <!-- Attachment Upload -->
      <!-- <div>
        <label>Attachments:</label>
        <input type="file" multiple (change)="onFilesSelected($event)" />
      </div> -->

      <!-- Preview Uploaded Files -->
      <div class="file-preview">
        <div *ngIf="selectedFiles.length > 0">
          <label>Selected Files:</label>
          <ul>
            <li *ngFor="let file of selectedFiles; let i = index">
              📎 {{ file.name }}
              <button type="button" (click)="removeFile(i)"><i class="fa fa-trash"></i></button>
            </li>
          </ul>
        </div>
      </div>

      <!-- <div class="modal-actions">
        <button (click)="attachment()">Attachment</button>
        <button (click)="sendReply()">Reply</button>
        <button (click)="resetReply()" type="button">Reset</button>
        <button (click)="closeReplyModal()" type="button">Cancel</button>
      </div> -->
    </div>
  </div>

  <!-- Assignment Popup -->
  <div class="popup-overlay" *ngIf="assignPopupVisible">
    <div class="popup">
      <h3>Assign Enquiry to Sales Person</h3>

      <!-- TODO E-19: review — was Bootstrap row/col-6; converted to two-col-row flex layout -->
      <div class="popup-fields two-col-row">
        <div style="text-align:right;"><strong>Organization:</strong></div>
        <div>{{ selectedRowData?.name }}</div>

        <div style="text-align:right;"><strong>Contact Person:</strong></div>
        <div>{{ selectedRowData?.contactPerson }}</div>

        <div style="text-align:right;"><strong>Email:</strong></div>
        <div>{{ selectedRowData?.email }}</div>

        <div style="text-align:right;"><strong>Subject:</strong></div>
        <div>{{ selectedRowData?.subject }}</div>
      </div>

      <label for="salesperson">Select Sales Person:</label>
      <select id="salesperson" [(ngModel)]="selectedSalespersonId" matInput>
        <option value="">-- Select --</option>
        <option *ngFor="let sp of salespersonList" [value]="sp.id">{{ sp.name }}</option>
      </select>

      <div class="popup-buttons">
        <button class="my-btn btn-success" (click)="confirmAssignment(selectedRowData?.id)">Assign</button>
        <button class="my-btn btn-secondary" (click)="cancelAssignment()">Cancel</button>
      </div>
    </div>
  </div>

  <!-- Confirmation Popup -->
  <div class="cancel-popup-overlay" *ngIf="showCancelPopup">
    <div class="cancel-popup-box">
      <h3>Cancel Enquiry</h3>
      <p>Are you sure you want to cancel this enquiry?</p>
      <div class="cancel-popup-actions">
        <button class="my-btn" (click)="confirmCancel()">OK</button>
        <button class="my-btn" (click)="closeCancelPopup()">Cancel</button>
      </div>
    </div>
  </div>


  <!-- Detail Popup -->
  <div class="modal-overlay" *ngIf="showDetail">
    <div class="modal-content">
      <h2 class="modal-title">Enquiry Details</h2>

      <!-- Basic Info -->
      <div class="basic-info-grid">
        <div><strong>Enq. Date:</strong> {{ selectedEnquiry?.createdDate | date:'MM/dd/yyyy' }}</div>
        <div><strong>Organization:</strong> {{ selectedEnquiry!.name }}</div>
        <div><strong>Contact Person:</strong> {{ selectedEnquiry!.contactPerson }}</div>

        <div><strong>Email:</strong> {{ selectedEnquiry!.email }}</div>
        <div><strong>Mobile No:</strong> {{ selectedEnquiry?.mobileNumber }}</div>
        <div><strong>Subject:</strong> {{ selectedEnquiry!.subject }}</div>

        <div><strong>Status:</strong>
          <span class="status-badge" [ngClass]="getStatusBadgeClass(selectedEnquiry?.stateHistory?.[0]?.status ?? '')">
            {{ selectedEnquiry?.stateHistory?.[0]?.status ?? '' }}
          </span>
          <!-- {{ selectedEnquiry?.enquiryStatus }} -->
        </div>
      </div>

      <div class="enquiry-detail">
        <strong>Enquiry Detail:</strong> {{ selectedEnquiry!.enquiryDetails }}
      </div>

      <!-- Tabs -->
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <h1 class="tab-button" [class.active]="activeTab==='assigned'" (click)="activeTab='assigned'">Assigned History
          </h1>
        </li>
        <li class="nav-item">
          <h1 class="tab-button" [class.active]="activeTab==='conversations'" (click)="activeTab='conversations'">
            Conversations</h1>
        </li>
        <li class="nav-item">
          <h1 class="tab-button" [class.active]="activeTab==='state'" (click)="activeTab='state'">State History</h1>
        </li>
      </ul>


      <!-- Tab Content -->
      <div class="tab-content">
        <!-- Assigned History -->
        <table class="detail-popup-table assigned-history-table" *ngIf="activeTab==='assigned'">
          <thead>
            <tr>
              <th>Assignee Name</th>
              <th>Email</th>
              <th>TimeStamp</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let a of selectedEnquiry?.assignedHistory">
              <td>{{ a.assigneeName }}</td>
              <td>{{ a.assigneeEmail }}</td>
              <td>{{ a.timeStamp | date:'MM/dd/yyyy' }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Conversations -->
        <table class="detail-popup-table conversations-table" *ngIf="activeTab==='conversations'">
          <thead>
            <tr>
              <th>Content</th>
              <th>Assignee</th>
              <th>Email</th>
              <!-- <th>TimeStamp</th> -->
              <th>Attachments</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of selectedEnquiry?.conversations">
              <td>{{ c.content }}</td>
              <td>{{ c.assigneeName }}</td>
              <td>{{ c.assigneeEmail }}</td>
              <!-- <td>{{ c.timeStamp | date:'MM/dd/yyyy' }}</td> -->
              <td>
                <!-- <div *ngFor="let att of c.attachments" class="attachment-item"> -->

                  <!-- Image preview -->
                  <!-- <ng-container *ngIf="att.fileType.startsWith('image/'); else downloadLink">
                    <img [src]="'data:' + att.fileType + ';base64,' + att.fileBytes" [alt]="att.fileName"
                      style="max-width:150px; max-height:150px; margin:5px; border:1px solid #ccc;" />
                  </ng-container> -->

                  <!-- Download for non-image -->
                  <!-- <ng-template #downloadLink>
                    <a [href]="'data:' + att.fileType + ';base64,' + att.fileBytes" [download]="att.fileName">
                      📎 {{ att.fileName }}
                    </a>
                  </ng-template> -->

                  <div *ngFor="let att of c.attachments" class="attachment-item">
                    <a [href]="'data:' + att.fileType + ';base64,' + att.fileBytes" [download]="att.fileName"
                      target="_blank">
                      📎 {{ att.fileName }}
                    </a>
                  </div>
                <!-- </div> -->
              </td>
            </tr>
          </tbody>
        </table>

        <!-- State History -->
        <table class="detail-popup-table state-history-table" *ngIf="activeTab==='state'">
          <thead>
            <tr>
              <th>Status</th>
              <th>TimeStamp</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of selectedEnquiry?.stateHistory">
              <td>{{ s.status }}</td>
              <td>{{ s.timeStamp | date:'MM/dd/yyyy' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button mat-flat-button color="primary" (click)="closeDetail()">Close</button>
      </div>
    </div>
  </div>


</div>
